module.exports = __webpack_public_path__ + "img/symbol_starred.b999c1eb.png";